import * as React from "react";
var Badge = function (_a) {
    var text = _a.text, color = _a.color;
    var bgColor = (color === null || color === void 0 ? void 0 : color.bg) || "bg-light-yellow";
    var textColor = (color === null || color === void 0 ? void 0 : color.text) || "text-[#B54708]";
    return (React.createElement("div", { className: "".concat(bgColor, " ").concat(textColor, " inline-flex items-center rounded-3xl px-2 py-1 text-xs font-semibold") }, text));
};
export default Badge;
